// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rVvyZ1OobnkxmYTJ2DC2{flex-direction:column;gap:40px;padding:37px 23px 0;display:flex}.dphB3J8U0sI6Qo21BNqT{flex-direction:column;display:flex}.qdNs7pTbzpsUjQl8jFGo{padding-bottom:20px}.veLu1E7HUkE5TIDAguuF{flex-direction:row;gap:12px;display:flex}.veLu1E7HUkE5TIDAguuF+.veLu1E7HUkE5TIDAguuF{margin-top:20px}.ssM5sm0F7ErHLsCRTdUs{width:130px;min-width:130px;max-width:130px;color:var(--content-primary-tertiary);padding:4px 0}.o_EuIRkgcZ4OZo1xlF8L{flex:1;min-width:0;padding:4px 0}.iG9mB1NzaB8DhoHXSpf_{color:var(--content-primary-disabled)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabContent": `rVvyZ1OobnkxmYTJ2DC2`,
	"section": `dphB3J8U0sI6Qo21BNqT`,
	"head": `qdNs7pTbzpsUjQl8jFGo`,
	"row": `veLu1E7HUkE5TIDAguuF`,
	"name": `ssM5sm0F7ErHLsCRTdUs`,
	"value": `o_EuIRkgcZ4OZo1xlF8L`,
	"placeholder": `iG9mB1NzaB8DhoHXSpf_`
};
export default ___CSS_LOADER_EXPORT___;
